const isNotOperationUser = (meta) => meta.dispatch(isNotOperationUserGuardAction(meta));

const isNotOperationUserGuardAction = (to) => (_dispatch, getState) => {

	const state = getState()

	if (state.auth.user.role.length === 1 && state.auth.user.role.find(r=> r.name === "Operation User")) {
		return '/'
	}

	return null
}

export { isNotOperationUser };
